import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const securitiesSubAccountMenuRegistry = {
    core_securitiesSubAccount: {
        label: "Securities Sub Account",
        link: PAGE_URL.SECURITIES_SUB_ACCOUNT_PAGE,
        key: PAGE_URL.SECURITIES_SUB_ACCOUNT_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default securitiesSubAccountMenuRegistry;
